export default __webpack_public_path__ + "static/group-20680-e899b90bd64ad0f92d28cce272f8b8d6.png";